// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let DialogV5 = require("./DialogV5.bs.js");
let TailwindMerge = require("tailwind-merge");
let JsxRuntime = require("react/jsx-runtime");

function ConfirmDialog(props) {
  let buttonsJustify = props.buttonsJustify;
  let justifyClass = buttonsJustify !== undefined ? (
      buttonsJustify === "flexStart" ? "justify-start" : (
          buttonsJustify === "flexEnd" ? "justify-end" : "justify-center"
        )
    ) : "";
  return JsxRuntime.jsxs(DialogV5.make, {
    title: props.title,
    isOpen: props.isOpen,
    ariaLabel: props.ariaLabel,
    onDismiss: props.onCancel,
    size: props.size,
    children: [
      props.body,
      JsxRuntime.jsx("div", {
        className: "mt-4"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          props.cancelButton,
          JsxRuntime.jsx("div", {
            className: "mr-2"
          }),
          props.confirmButton
        ],
        className: TailwindMerge.twMerge([
          "flex flex-row",
          justifyClass
        ])
      })
    ]
  });
}

let make = ConfirmDialog;

exports.make = make;
/* DialogV5 Not a pure module */
